import { render, staticRenderFns } from "./QzJingYingxj.vue?vue&type=template&id=2584a3e8&scoped=true"
import script from "./QzJingYingxj.vue?vue&type=script&lang=js"
export * from "./QzJingYingxj.vue?vue&type=script&lang=js"
import style0 from "./QzJingYingxj.vue?vue&type=style&index=0&id=2584a3e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584a3e8",
  null
  
)

export default component.exports